<app-abstract-dialog [dialogWidth]="'800'"
                     [showVoiceControls]="false"
                     [showCloseButton]="false">
    <ng-container abstract-header>
        <h3 class="abstract-dialog__header__title">{{'GENERAL.SELECTED_FILES' | translate}}</h3>
    </ng-container>
    <ng-container abstract-content>
        <ul class="list">
            <li class="list__item" *ngFor="let file of files; let index = index;">
                {{file.name}}
                <app-button
                        [ariaLabel]="'GENERAL.CLOSE' | translate"
                        [cssClasses]="'icon-padding'"
                        [icon]="'close'"
                        [iconColor]="'gray-08'"
                        (buttonClicked)="onDeleteFiles(file)">
                </app-button>
            </li>
        </ul>
    </ng-container>

    <ng-container abstract-footer>
        <div class="abstract-dialog__footer__buttons-wrapper">
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [cssClasses]="'small outlined outlined__gray-07'"
                        (buttonClicked)="close()">
                    {{'GENERAL.CANCEL' | translate}}
                </app-button>
            </div>
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [tabindex]="1"
                        [cssClasses]="'small solid__blue-07'"
                        [disabled]="files.length === 0"
                        (buttonClicked)="onUploadFiles(this.files)">
                    {{'GENERAL.UPLOAD' | translate}}
                </app-button>
            </div>
        </div>
    </ng-container>
</app-abstract-dialog>
